import React from "react";
import Recent from "./RecentActivity";
import { Container, Wrapper, Title, Icon } from "./style";

const Dashboard = () => (
  <Container>
    <Wrapper main margin="title">
      <Title title color="title" Size="title" lineHeight="title">
        Howdy, Darell!
      </Title>
      <Title margin="desc" color="desc" Size="desc" lineHeight="desc">
        Ready to jump in?
      </Title>
    </Wrapper>
    <Wrapper.Contents main>
      <Wrapper.Contents items>
        <Icon.Home />
        <Wrapper content>
          <Title title color="blue" Size="title" lineHeight="title">
            15
          </Title>
          <Title title size="desc" color>
            My Properties
          </Title>
        </Wrapper>
      </Wrapper.Contents>
      <Wrapper.Contents items>
        <Icon.View />
        <Wrapper content>
          <Title title color="blue" Size="title" lineHeight="title">
            22
          </Title>
          <Title title size="desc" color>
            Total Views
          </Title>
        </Wrapper>
      </Wrapper.Contents>
      <Wrapper.Contents items>
        <Icon.Inbox />
        <Wrapper content>
          <Title title color="blue" Size="title" lineHeight="title">
            921
          </Title>
          <Title title size="desc" color>
            Inbox
          </Title>
        </Wrapper>
      </Wrapper.Contents>
      <Wrapper.Contents items>
        <Icon.Favorite />
        <Wrapper content>
          <Title title color="blue" Size="title" lineHeight="title">
            921
          </Title>
          <Title title size="desc" color>
            Total Properties
          </Title>
        </Wrapper>
      </Wrapper.Contents>
    </Wrapper.Contents>
    <Wrapper chart>
      {/* <Chart /> */}
      <Recent />
    </Wrapper>
    <Title copy margin="copy" color="desc" Size="desc" lineHeight="desc">
      Copyright © 2021 CreativeLayers. All Right Reserved.
    </Title>
  </Container>
);

export default Dashboard;
